export enum ProfileFieldName {
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    EMAIL = 'email',
    MOBILE_NUMBER = 'mobileNumber',
    PAYROLL_NUMBER = 'datacomId',
    GROUPS = 'groupIds',
    ROLES = 'roleIds',
    SPRAY_OPERATOR = 'isSprayOperator'
}

export enum CertificationsFieldName {
    CERTIFICATION_PENDING = 'isCertificationPending',
    CERTIFICATE_NUMBER = 'sprayCertification.externalId',
    CERTIFICATE_EXPIRY_DATE = 'sprayCertification.endDate'
}

export enum NotificationsFieldName {
    SUBSCRIBE_HARVEST_EMAIL = 'isSubscribedToHarvestEmail',
    SUBSCRIBE_HARVEST_SMS = 'isSubscribedToHarvestSms'
}

export enum TabName {
    PROFILE = 'Profile',
    CERTIFICATIONS = 'Certifications',
    NOTIFICATIONS = 'Notifications'
}
